
import React, { Component } from 'react';
import ReactDOM from 'react-dom';

import MeApi from "../../lib/users/me-api";
import AlertManager from "../../managers/alert/alert-manager";
import Row from '../../utils/row';
import CreateButton from '../../components/buttons/create-button';
import Divider from '../../components/divider/divider';
import List from '../../components/list/list';

import Container from '../../containers/container';
import ContainerTable from '../../containers/container-table';
import ButtonNext from '../../components/buttons-navigation/button-next';
import { stringToFriendlyDatetime } from '../../lib/helpers/datetime-helpers';
import ContainerIndex from '../../containers/container-index';

import AccountMessagesMessage from './components/account-messages-message';
import { default as ContactAccountMessage} from '../contacts/components/account-messages-message';

import PopupsNewMessage from './popups/popups-new-message';

import PageLayout from "../../containers/layout/page-layout";
import { MinMaxLayout } from "../../containers/layout";

import PopupContext, { PopupProvider } from '../../context/context-popup';

import adminApi from '../../lib/admin/admin-api';
import Dropdown from '../../components/inputs/inputs-dropdown';
import LabelContainer from '../../components/label-container';
import { SmallPill } from '../../components/pills';

import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css'

import SearchResultsError from '../../components/content-search/search-results-error';

const Unread = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="20" viewBox="0 0 22 20">
            <path id="Path_441" data-name="Path 441" d="M18.8,8.493A5.023,5.023,0,0,0,22,8.9V20a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1V4A1,1,0,0,1,3,3H16.1a5.01,5.01,0,0,0,1.093,4.241l-5.132,4.442L5.647,6.238,4.353,7.762l7.72,6.555ZM21,7a3,3,0,1,1,3-3A3,3,0,0,1,21,7Z" transform="translate(-2 -1)" fill="#fff"/>
        </svg>
    )
}

const Read = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="19.833" viewBox="0 0 20 19.833">
            <path id="Path_443" data-name="Path 443" d="M2.243,6.854,11.49,1.31a1,1,0,0,1,1.029,0l9.238,5.545A.5.5,0,0,1,22,7.284V20a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1V7.283a.5.5,0,0,1,.243-.429ZM4,8.133V19H20V8.132L17.209,6.456,12,3.332l-8,4.8ZM12.06,13.7l5.3-4.463,1.288,1.53L12.074,16.3l-6.71-5.53L6.636,9.228,12.06,13.7Z" transform="translate(-2 -1.167)" fill="#354859"/>
        </svg>
    )
}

export default class Messages extends Component {
    static contextType = PopupContext;

    constructor(props) {
        super(props);

        this.state = {
            errors: [],
            popup: null,
            selectedMessage: null,
            messages: [],
            currentPage: 1,
            adminTeams: [],
            meta: {},
            sortMessages: {
                label: 'Sort by updated at',
                value: 'updated_at'
            },
            adminTeam: null,
            filterMessages: null,
            filterUnread: null,
            direction: {
                label: 'Sort by Descending',
                value: 'desc'
            }
        };
    }

    componentDidMount() {
        this.fetch();
        this.fetchAdminTeams();
    }

    fetchAdminTeams() {
        MeApi.me().then((data) => {
            this.setState({ adminTeams: data.admin_teams })
        });
    }

    fetch() {
        const data = {
            per_page: 10,
            page: this.state.currentPage,
            order_by: this.state.sortMessages?.value,
            order_direction: this.state.direction?.value,
            created_by_type: this.state.filterMessages?.value?.length > 0 ? this.state.filterMessages?.value : null,
        }

        if (this.state.adminTeam !== null) {
            data.admin_team_ids = [ this.state.adminTeam.value ];
        }

        if (this.state.filterUnread !== null) {
            data.with_unread_messages = this.state.filterUnread?.value;
        }

        MeApi.getConversations(data).then(({ meta, data }) => {
            this.setState({ messages: data, meta: meta });
        })
    }

    handleChange(e) {
        this.setState({[e.target.name] : e.target.value});
    }

    selectMessage(msg) {
        this.setState({ selectedMessage: msg });
    }

    openNewMessagePopup() {
        const { setPopup } = this.context;

        setPopup(<PopupsNewMessage fetch={this.fetch.bind(this)}/>);
    }

    getAdminTeam(team) {
        if (typeof team === 'object') return team?.name;

        return this.state.adminTeams.find(t => t.id === team)?.name;
    }

    renderTable() {
        if (this.state.messages?.length === 0) return <SearchResultsError
            message='Uh-oh!'
            body={<>
                <b>No results have come back, please refine your search</b>
            </>}
        />

        let messages = [];

        this.state?.messages?.forEach(msg => {
            messages.push([
                msg?.user_unread_messages?.length > 0,
                msg.subject,
                this.getAdminTeam(msg?.admin_team_id),
                msg.members,
                stringToFriendlyDatetime(msg.updated_at),
                msg.id,
            ])
        })

        return (
            <>
                <ContainerTable
                    className="dashboard-progress"
                    columns={[
                        { field: 'STATUS', width: '10%' },
                        { field: 'SUBJECT', width: '30.8196721%' },
                        { field: 'TEAM', width: '10%' },
                        { field: 'IN THIS CONVERSATION', width: '20%' },
                        { field: 'LAST UPDATE', width: '20%' },
                        { field: '', width: '9.1803279%' }
                    ]} data={[
                        ...messages
                    ]}
                    style={{
                        backgroundColor: 'transparent',
                        padding: '0px',
                        position: 'relative'
                    }}
                    rowStyle={{
                        backgroundColor: '#FCF7FF',
                    }}
                    insertBeforeCell={index => {
                        const createdByType = this.state.messages[index]?.created_by_type;

                        return null;

                        return (
                            <div style={{
                                width: '20px',
                                height: '20px',
                                backgroundColor: createdByType === 'App\Models\User' ? 'red' : 'blue',
                                borderRadius: '50%',
                                position: 'absolute',
                                left: '-10px'
                            }}></div>
                        )
                    }}
                    replaceColumn={{
                        0: (data) => {
                            return (
                                <div style={{
                                    backgroundColor: data === true ? '#FF7612' : '#F4EAFA',
                                    width: '100%',
                                    height: '100%',
                                    padding: '25px 0px',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    borderRadius: '10px 0px 0px 10px',
                                    position: 'relative'
                                }}>
                                    { data === true ? <Unread/> : <Read/> }
                                </div>
                            )
                        },
                        2: (data) => {
                            return data !== undefined ? <SmallPill>{ data }</SmallPill> : ''
                        },
                        3: (data) => {
                            return (
                                <Row gap="10px" alignItems="center">
                                    { data.map((message, index) => {
                                        return (
                                            <React.Fragment key={index}>
                                                <Container.Icon
                                                    className={`user-${index}`}
                                                    src={message?.user_profile?.profile_img || '/assets/user-icon.svg'}
                                                    style={{
                                                        width: '30px',
                                                        height: '30px',
                                                        borderRadius: '50%',
                                                        backgroundColor: 'white',
                                                        border: '1px solid black'
                                                    }}
                                                />
                                                <Tooltip
                                                    anchorSelect={`.user-${index}`}
                                                    content={message?.name}
                                                />
                                            </React.Fragment>
                                        )
                                    })}
                                    { data.length > 5 && <Container.Text color="#C6C7D2">+ More</Container.Text> }
                                </Row>
                            )
                        },
                        5: (data) => {
                            return (
                                <Row style={{
                                    width: '100%',
                                    paddingRight: '25px'
                                }} justifyContent='flex-end'>
                                    <ButtonNext onClick={() => this.selectMessage(data)}>View</ButtonNext>
                                </Row>
                            )
                        }
                    }}
                ></ContainerTable>
                <ContainerIndex.Pagination
                    currentPage={this.state.currentPage}
                    maxPages={this.state.meta?.last_page}
                    onPrevious={() => this.setState({ currentPage: this.state.currentPage - 1 }, () => this.fetch())}
                    onNext={() => this.setState({ currentPage: this.state.currentPage + 1 }, () => this.fetch())}
                />
            </>
        )
    }

    renderContent() {
        if (this.state.selectedMessage !== null) {

            const conversation = this.state.messages.find(c => {
                return c.id === this.state.selectedMessage;
            })

            if(conversation.created_by_type === "App\\Models\\Contact") {
                return <ContactAccountMessage
                    data={conversation}
                    id={this.state.selectedMessage} return={() => {
                    this.selectMessage(null);
                    this.fetch();
                }}
                />
            }

            return <AccountMessagesMessage id={this.state.selectedMessage} return={() => {
                this.selectMessage(null);
                this.fetch();
            }}/>
        }

        return (
            <Container>
                <Container.Header>
                    <Row justifyContent='space-between' alignItems='center'>
                        <Container.Title color="#354859" fontSize="40px">Messages</Container.Title>
                        <CreateButton onClick={this.openNewMessagePopup.bind(this)}>Create</CreateButton>
                    </Row>
                    <Divider/>
                    <List gap="20px">
                        <Row gap="40px" wrap={true}>
                            <Dropdown
                                label="Sort"
                                items={
                                    [
                                        {
                                            label: 'Sort by updated at',
                                            value: 'updated_at'
                                        },
                                        {
                                            label: 'Sort by created at',
                                            value: 'created_at'
                                        }
                                    ]
                                }
                                value={this.state.sortMessages}
                                onChange={val => this.setState({ sortMessages: val }, () => this.fetch())}
                            />
                            <Dropdown
                                label="Direction"
                                items={
                                    [
                                        {
                                            label: 'Sort by Ascending',
                                            value: 'asc'
                                        },
                                        {
                                            label: 'Sort by Descending',
                                            value: 'desc'
                                        },
                                    ]
                                }
                                value={this.state.direction}
                                onChange={val => this.setState({ direction: val }, () => this.fetch())}
                            />
                            <Dropdown
                                label="Type"
                                defaultSelected={true}
                                reset
                                resetText="All"
                                items={
                                    [
                                        {
                                            label: 'Filter by contact',
                                            value: 'App\\Models\\Contact'
                                        },
                                        {
                                            label: 'Filter by user',
                                            value: 'App\\Models\\User'
                                        },
                                    ]
                                }
                                value={this.state.filterMessages}
                                onChange={val => this.setState({ filterMessages: val }, () => this.fetch())}
                                onReset={() => this.setState({ filterMessages: null }, () => this.fetch())}
                            />
                            <Dropdown
                                label="Unread / Read"
                                reset
                                resetText="All"
                                defaultSelected={true}
                                items={
                                    [
                                        {
                                            label: 'Filter by Unread',
                                            value: 1
                                        },
                                        {
                                            label: 'Filter by Read',
                                            value: 0
                                        },
                                    ]
                                }
                                value={this.state.filterUnread}
                                onChange={val => this.setState({ filterUnread: val }, () => this.fetch())}
                                onReset={() => this.setState({ filterUnread: null }, () => this.fetch())}
                            />
                             <Dropdown
                                label="Filter by team"
                                reset
                                resetText="All"
                                defaultSelected={true}
                                items={
                                    this.state.adminTeams.map((data) => {
                                        return {
                                            label: data?.name,
                                            value: data.id,
                                        }
                                    })
                                }
                                value={this.state.adminTeam}
                                onChange={val => this.setState({ adminTeam: val }, () => this.fetch())}
                                onReset={() => this.setState({ adminTeam: null })}
                            />
                            {/* <Row gap="20px">
                                <LabelContainer label="User">
                                    <div style={{
                                        width: '30px',
                                        height: '30px',
                                        backgroundColor: 'red',
                                        borderRadius: '50%'
                                    }}></div>
                                </LabelContainer>
                                <LabelContainer label="Contact">
                                    <div style={{
                                        width: '30px',
                                        height: '30px',
                                        backgroundColor: 'blue',
                                        borderRadius: '50%'
                                    }}></div>
                                </LabelContainer>
                            </Row> */}
                        </Row>
                    </List>
                    <Divider/>
                </Container.Header>
                <Container.Content>
                    <List gap='40px'>
                        { this.renderTable() }
                    </List>
                </Container.Content>
            </Container>
        )
    }

    render() {
        return (
            <PageLayout>
                <MinMaxLayout main={this.renderContent()} />
            </PageLayout>
        );
    }

}

const el = document.getElementById('messages');

if (el) {
    ReactDOM.render(<>
        <PopupProvider>
            <Messages/>
        </PopupProvider>
    </>, el);
}
